import { render, staticRenderFns } from "./VformProjectListModal.vue?vue&type=template&id=04de11b4&"
import script from "./VformProjectListModal.vue?vue&type=script&lang=js&"
export * from "./VformProjectListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports